import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, IconButton, Typography } from "@material-ui/core";
import { Delete, DragIndicator } from "@material-ui/icons";
import { SortableElement, SortableHandle } from "react-sortable-hoc";

const useStyles = makeStyles((theme) => ({
  title: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
    marginBottom: "16px",
  },
  container: {
    width: "100%",
    marginInline: "auto",
    padding: "8px 20px",
    marginBottom: "8px",
    color: theme.palette.background.default,
    backgroundColor: theme.palette.warning.main,
    borderRadius: "8px",
    borderBottomWidth: "3px",
    borderBottomColor: theme.palette.warning.dark,
    borderBottomStyle: "solid",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
  deleteBtn: {
    color: theme.palette.background.default,
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
  },
}));

const DragHandle = SortableHandle(() => <DragIndicator />);

function SortingElement({ title, id, handleDelete }) {
  const classes = useStyles();
  return (
    <Box className={classes.container} id={id}>
      <Typography>{title}</Typography>
      <Box className={classes.buttonsContainer}>
        <IconButton
          size="small"
          className={classes.deleteBtn}
          onClick={handleDelete}
        >
          <Delete />
        </IconButton>
        <DragHandle />
      </Box>
    </Box>
  );
}

export default SortableElement(SortingElement);
